import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../core/providers/AuthProvider';
import { Icon } from '../../../../core/design-system/components/Icon';
import { Button } from '../../../../core/design-system/components/Button';

const UserListItem = ({ 
  user, 
  activeTab, 
  isOwnProfile, 
  processingIds, 
  handleAccept, 
  handleReject, 
  handleUnfollow, 
  handleRemoveFollower, 
  t, 
  onClose 
}) => {
  const { user: currentUser } = useAuth();
  const navigate = useNavigate();
  
  // Dans le contexte followers/following, tous les profils devraient être accessibles
  const canNavigate = Boolean(user?.uid);

  // Navigation personnalisée qui contourne les restrictions du hook
  const handleCustomNavigate = () => {
    if (!user?.uid) return;
    
    if (currentUser?.uid === user.uid) {
      // Si c'est le propre profil de l'utilisateur
      navigate('/dashboard/profile');
    } else {
      // Sinon, naviguer vers le profil spécifique
      navigate(`/dashboard/profile/${user.uid}`);
    }
  };

  const handleAvatarClick = async () => {
    if (!canNavigate) {
      return;
    }
    
    try {
      if (onClose) {
        onClose();
      }
      
      handleCustomNavigate();
    } catch (error) {
      console.error('Error navigating to profile:', error);
    }
  };

  return (
    <li key={user.uid} className="user-item">
      <div className="user-info">
        <div 
          className="user-avatar" 
          onClick={canNavigate ? handleAvatarClick : undefined} 
          style={{ 
            cursor: canNavigate ? 'pointer' : 'default',
            opacity: canNavigate ? 1 : 0.7
          }}
        >
          {user.photoURL ? (
            <img src={user.photoURL} alt={user.displayName} />
          ) : (
            <div className="avatar-placeholder">
              <Icon name="user" size={20} />
            </div>
          )}
        </div>
        <div className="user-details">
          <span className="user-name">{user.displayName}</span>
        </div>
      </div>
      <div className="user-actions">
        {activeTab === 'requests' && isOwnProfile && (
          <>
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleReject(user.uid)}
              disabled={processingIds.includes(user.uid)}
              className="reject-button"
            >
              {t('actions.reject')}
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={() => handleAccept(user.uid)}
              disabled={processingIds.includes(user.uid)}
              className="accept-button"
            >
              {t('actions.accept')}
            </Button>
          </>
        )}
        {activeTab === 'following' && isOwnProfile && (
          <Button
            variant="outlined"
            size="small"
            onClick={() => handleUnfollow(user.uid)}
            disabled={processingIds.includes(user.uid)}
            className="unfollow-button"
          >
            {t('actions.unfollow')}
          </Button>
        )}
        {activeTab === 'followers' && isOwnProfile && (
          <Button
            variant="outlined"
            size="small"
            onClick={() => handleRemoveFollower(user.uid)}
            disabled={processingIds.includes(user.uid)}
            className="reject-button"
            style={{
              backgroundColor: '#ff4757',
              color: 'white',
              borderColor: '#ff4757',
              fontWeight: 'bold'
            }}
          >
            {t('actions.remove')}
          </Button>
        )}
      </div>
    </li>
  );
};

export default UserListItem; 